import { AsyncSelect, type AsyncSelectProps } from '@vestigas/ui';

type AsyncEntitySelectProps<TItem, TPageParam, TFilters> = AsyncSelectProps<
  TItem,
  TPageParam,
  TFilters
> & {
  readonly hasReadPermission?: boolean;
};

export function AsyncEntitySelect<
  TItem,
  TPageParam = number,
  TFilters = undefined,
>({
  hasReadPermission = false,
  isDisabled,
  ...props
}: AsyncEntitySelectProps<TItem, TPageParam, TFilters>) {
  return (
    <AsyncSelect<TItem, TPageParam, TFilters>
      {...props}
      isDisabled={isDisabled || !hasReadPermission}
    />
  );
}
